// @flow
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import {withStyles} from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import styles from './Category.styles.js';

class CategoryBase extends React.Component<Props> {

  render() {
    const {classes, className, name, slug} = this.props;
    return (
      <Typography color="textSecondary" inline>
        {(name &&
          <Link to={`/category/${slug}`} className={classNames(className, classes)}>
            {name}
          </Link>) || <Skeleton width={70} height={20} />
        }
      </Typography>
    );
  }
}

const Component = withStyles(styles, {withTheme: true})(
  ({classes, color, ...other}) => {
    return <CategoryBase className={(classes.root)} {...other} />
  }
);

export {Component as Category};
export default Component;